import PropTypes from 'prop-types'

export const propTypes = {
  className: PropTypes.string,
  emissions: PropTypes.any,
  onClose: PropTypes.func.isRequired
}

export const defaultProps = {}
